<template>
  <div>
    <nav-title />
    <div class="filter">
      <el-input type="number" size="small" v-model="id" placeholder="模板ID" />
      <el-input size="small" v-model="name" placeholder="模板名称" />
      <!-- <el-input type="number" size="mini" v-model="size" placeholder="大小"/> -->
      <el-button size="small" @click="resetCondition">重置</el-button>
      <el-button size="small" @click="batchDelete(selection)"
        >批量删除</el-button
      >
    </div>
    <div class="container">
      <el-table
        ref="table"
        :data="list"
        stripe
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="模板ID" width="80"> </el-table-column>
        <el-table-column prop="name" label="模板名称"> </el-table-column>
        <el-table-column prop="name" label="模板预览">
          <template slot-scope="scope">
            <img
              class="template-img"
              :src="scope.row.default_image"
              @click="showPreview(scope.row.default_image, 'img')"
              alt=""
            />
          </template>
        </el-table-column>
        <el-table-column prop="video_size" label="大小">
          <template slot-scope="scope">
            <p>{{ fixSize(scope.row.video_size) }} M</p>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="投放成本">
          <template slot-scope="scope">
            <p>
              {{ fixSize(scope.row.video_size, 0.2) }}
              ￥/CPM
            </p>
          </template>
        </el-table-column>
        <el-table-column label="坑位数量">
          <template slot-scope="scope">
            <p>{{ (scope.row.config || []).length }}</p>
          </template>
        </el-table-column>
        <el-table-column label="尺寸">
          <template slot-scope="scope">
            <p>{{ scope.row.width }} * {{ scope.row.height }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" min-width="100" label="更新时间">
          <template slot-scope="scope">
            <p>
              {{ setMoment(scope.row.update_time) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="159">
          <template slot-scope="scope">
            <span
              class="action"
              @click="showPreview(scope.row.default_video, 'video', '播放')"
            >
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-play"></use>
              </svg>
            </span>
            <span
              class="action"
              @click="editVideo(scope.row.id, scope.row.template_type)"
            >
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-edit"></use></svg
            ></span>
            <span class="action" @click="previewVideo(scope.row)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-preview"></use></svg
            ></span>
            <!-- <span class="action" @click="handleActivate(scope.row.id, scope.row.isOpen === 1? 0:1)">{{scope.row.isOpen === 1? '禁用':'启用'}}</span> -->
            <!-- <span class="action" @click="downLoad(scope.row)">下载</span> -->
            <span class="action" @click="remove(scope.row.id)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-delete"></use></svg
            ></span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination" v-if="list.length">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
      <el-dialog
        class="preview-dialog"
        :title="previewTitle"
        :visible.sync="preview"
      >
        <img
          v-if="previewType === 'img'"
          :src="url"
          style="max-height:500px;max-width:100%;"
        />
        <video
          class="video"
          autoplay
          v-else-if="previewType === 'video'"
          :src="url"
          controls
        />
        <video class="video" v-else :src="url" autoplay controls />
      </el-dialog>
      <el-dialog
        class="preview-dialog"
        title="预览"
        :visible.sync="previewMaterial"
      >
        <video class="video" v-if="preview_url" :src="preview_url" controls />
        <div class="group" v-else-if="preview_item">
          <div
            class="image"
            v-for="(data, index) in preview_item.config"
            :key="index"
          >
            <images-upload
              :fileList="[data]"
              :index="index"
              :extra="{ config: preview_item.config, data, index }"
              :limit="preview_item.config.length"
              :multiple="preview_item.config.length > 1"
              @change="setMaterial"
            />
          </div>
          <p v-if="preview_item.config.length > 1">tips: 支持批量上传</p>
          <el-button type="primary" size="mini" @click.stop="previewResult"
            >预览</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Axios from 'utils/axios';
import ImageUpload from 'components/image-upload';
import { convertJSON, copyText } from 'utils/helper';
import moment from 'moment';
import ImagesUpload from 'components/upload/UploadWrapper';
import NavTitle from 'components/NavTitle';
import ListMixins from 'mixins/list';

export default {
  name: 'VideoList',
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'video',
      selection: [],
      dialogVisible: false,
      url: '',
      preview_url: '',
      preview: false,
      preview_item: null,
      previewMaterial: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        fileContent: [{ required: true, message: '请上传模板' }]
      },
      form: {
        name: '',
        tagIds: [],
        fileContent: null
      },
      previewType: '',
      moment: moment,
      id: '',
      name: '',
      size: '',
      previewTitle: '预览',
      filterValues: { design_type: 0 }
    };
  },
  watch: {
    // selection(){
    // 	this.queryList()
    // },
    dialogVisible(value) {
      if (!value) {
        this.form.name = '';
        this.form.tagIds = [];
        this.form.fileContent = null;
      }
    },
    id() {
      this.queryList();
    },

    name() {
      this.queryList();
    }
  },
  components: {
    'image-upload': ImageUpload,
    'nav-title': NavTitle,
    ImagesUpload
  },
  computed: {
    list() {
      return this.$store.state.video.list || [];
    },
    total() {
      return this.$store.state.video.total;
    },
    limit() {
      return this.$store.state.video.pageSize;
    },
    tags() {
      return this.$store.state.tags.list || [];
    }
  },
  beforeDestroy() {
    this.$store.commit('video/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    setMoment(data) {
      return moment(data).format('YYYY-MM-DD hh:mm:ss');
    },
    fixSize(data, rate) {
      return ((data / 1024 / 1024) * (rate || 1)).toFixed(2);
    },
    remove(id) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('video/delete', { ids: [id] }).then(() => {
            this.$message.success('删除成功');
            this.refreshData();
          });
        })
        .catch();
    },
    bg(item) {
      try {
        var res = JSON.parse(item.task_api_response);
      } catch (e) {
        res = { data: {} };
      }
      const url = res.data.snapshoturl;
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      };
    },
    copyLink(item) {
      try {
        var res = JSON.parse(item.task_api_response);
      } catch (e) {
        res = { data: {} };
      }
      const url = res.data.ourOssUr;
      copyText(url);
      this.$message.success('复制成功');
    },
    editVideo(id, type) {
      if (type === 2) {
        this.$router.push('/ae/edit/' + id);
      } else {
        this.$router.push('/video/edit/' + id);
      }
    },
    saveVideo(item) {
      this.$store.dispatch('video/save', item);
    },
    playVideo(item) {
      try {
        var res = JSON.parse(item.task_api_response);
      } catch (e) {
        res = { data: {} };
      }
      this.url = res.data.ourOssUr;
      this.preview = true;
    },
    queryList() {
      this.$store.commit('video/update', {
        condition: {
          name: this.name || undefined,
          tagIds: this.selection.join(',') || undefined,
          id: this.id || undefined,
          size: this.size || undefined
        }
      });
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    handleSizeChange(pageSize) {
      this.$store.commit('video/update', {
        page: 1,
        pageSize
      });
      this.fetchData();
    },
    handleChangePage(page) {
      this.$store.commit('video/update', {
        page
      });
      this.fetchData();
    },
    previewVideo(data) {
      this.preview_item = data;
      this.preview_url = '';
      this.previewMaterial = true;
    },
    setMaterial(urls, { data, config, index }) {
      let imageIndex = 0;
      this.preview_item.content.resource = this.preview_item.content.resource
        ? this.preview_item.content.resource
        : {};
      _.each(this.preview_item.config, (item, num) => {
        if (num >= index && urls.length > imageIndex) {
          item.url = urls[imageIndex];

          if (this.preview_item.template_type === 1) {
            this.preview_item.content.resource[item.name] = urls[imageIndex++];
          } else {
            var key = item.name.slice(2);
            var elementIndex = this.preview_item.ae_content.userElements.findIndex(
              res => res.name === key
            );
            if (elementIndex >= 0) {
              var type = this.preview_item.ae_content.userElements[elementIndex]
                .type;
              if (type === 'text') {
                this.preview_item.ae_content.userElements[elementIndex].value =
                  urls[imageIndex++];
              } else {
                this.preview_item.ae_content.userElements[
                  elementIndex
                ].sampleUrl = urls[imageIndex++];
              }
            }
          }
        }
      });
      this.preview_item.config = JSON.parse(
        JSON.stringify(this.preview_item.config)
      );
    },
    previewResult() {
      const loading = this.$loading({
        lock: true,
        text: '正在创建, 请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.preview_item.template_type === 1) {
        Axios.post('/admin/videoTemplate/previewVideo', {
          content: this.preview_item.content
        })
          .then(res => {
            loading.close();
            if (typeof res === 'string') {
              this.preview_url = res;
            }
          })
          .catch(e => {
            loading.close();
          });
      } else {
        Axios.post('/admin/videoTemplate/ae/preview', {
          ae_type: this.preview_item.ae_type,
          ae_content: this.preview_item.ae_content
        })
          .then(res => {
            loading.close();
            if (typeof res.data === 'string') {
              this.url = res.data;
              this.preview = true;
            }
          })
          .catch(e => {
            loading.close();
          });
      }
    },

    handleSelectionChange(selection) {
      this.selection = selection.map(item => item.id);
    },
    showPreview(url, type, title) {
      this.previewType = type;
      this.url = url;
      this.preview = true;
      this.previewTitle = title || '预览';
    },

    resetCondition() {
      this.$store.commit('video/update', {
        condition: {}
      });
      this.id = null;
      this.size = '';
      this.name = '';
      this.refreshData();
    },

    batchDelete(ids) {
      this.$confirm('是否删除?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$refs.table.clearSelection();
        this.$store
          .dispatch('video/delete', {
            ids: ids
          })
          .then(() => {
            this.selection = [];
            this.$message.success('删除成功');
            this.refreshData();
          });
      });
    },
    downLoad(row) {
      // 这是传统的下载方式
      const downloadFileA = document.createElement('a');
      document.body.append(downloadFileA);
      downloadFileA.href = row.default_video;
      downloadFileA.download = row.name + '.mp4';
      // 超链接 target="_blank" 要增加 rel="noopener noreferrer" 来堵住钓鱼安全漏洞。如果你在链接上使用 target="_blank"属性，并且不加上rel="noopener"属性，那么你就让用户暴露在一个非常简单的钓鱼攻击之下。(摘要)
      downloadFileA.rel = 'noopener noreferrer';
      downloadFileA.click();
      document.body.removeChild(downloadFileA);
    }
  }
};
</script>

<style scoped lang="scss">
.preview-dialog {
  text-align: center;
}
.video {
  height: 400px;
  max-width: 100%;
}
.time {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}
</style>

<style lang="scss" scoped>
.action {
  color: #3fb7ff;
  font-size: 16px;
  margin-right: 14px;
  :last-child {
    margin: 0;
  }
}
.template-img {
  max-width: 100px;
  max-height: 50px;
  cursor: pointer;
}
.container {
  background: white;
  border-radius: 0 0 4px 4px;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;
}

.filter {
  background: #fff;
  display: flex;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  border-radius: 4px 4px 0 0;
  > * {
    margin: 0 8px 0 0;
    max-width: 150px;
  }
}
</style>
